export const articles = [
  {
    id: 1,
    slug: 'tongren-manhua-jiaoben-rumen',
    title: '同人漫画脚本入门：从灵感到完整故事',
    excerpt: '掌握同人漫画脚本写作的基础流程，学习如何将灵感转化为结构完整、角色鲜活的漫画故事。',
    content: `<p>同人漫画的创作之旅，始于一个精彩的脚本。一个好的脚本不仅决定了故事的走向，更是整个漫画创作的蓝图。本文将带你从零开始，系统学习同人漫画脚本的写作方法。</p>
<h2>一、灵感的捕捉与整理</h2>
<p>灵感往往转瞬即逝。建议随时携带笔记本或使用手机备忘录，记录下每一个有趣的念头。当你看到一段精彩的对话、一个有趣的场景，甚至是一个独特的角色设定时，立刻记下来。这些碎片化的灵感积累到一定程度后，往往能拼凑出完整的故事框架。</p>
<p>整理灵感时，可以按以下维度分类：角色设定、世界观背景、核心冲突、关键情节转折点。这样在后续创作时，可以快速找到需要的素材。</p>
<h2>二、角色塑造的核心要素</h2>
<p>同人创作中，角色往往已有原作基础。但优秀的同人脚本需要在原作设定之上，赋予角色更深层的内心世界。每个角色都应该有明确的动机、独特的性格特征，以及在故事中需要面对的成长课题。</p>
<p>创建角色档案时，除了基本信息外，还应该包含：角色在故事中的目标是什么？阻碍他达成目标的障碍是什么？他在故事前后的变化是什么？这些问题的答案将构成角色弧光的基础。</p>
<h2>三、故事结构的搭建</h2>
<p>经典的三幕式结构同样适用于同人漫画脚本：</p>
<p><strong>第一幕（铺垫）</strong>：介绍角色、世界观和日常状态，设置故事的核心冲突或悬念，吸引读者继续阅读。</p>
<p><strong>第二幕（对抗）</strong>：冲突逐步升级，角色面临越来越大的挑战，在这个过程中的选择和反应塑造角色的深度。</p>
<p><strong>第三幕（解决）</strong>：冲突达到高潮后得到解决，角色完成成长，故事主题得到升华。</p>
<h2>四、对话写作的技巧</h2>
<p>漫画中的对话需要简洁有力。每个角色的对白都应该反映其性格特征，避免所有角色说着相同风格的台词。好的对话应该做到：推动剧情发展、展现角色性格、提供必要信息，三者至少满足其一。</p>
<p>同时要注意对话的节奏感，在紧张场景中使用短句加快节奏，在抒情场景中可以适当放慢节奏。</p>
<h2>五、脚本格式规范</h2>
<p>标准的漫画脚本通常包含以下元素：页码、场景描述、角色动作、对话内容、音效标注。保持格式统一有助于后续与画师（如果是合作创作）的沟通，也能让自己在创作时思路更清晰。</p>`,
    category: '脚本写作',
    categorySlug: 'jiaoben-xiezuo',
    tags: ['脚本写作', '角色塑造', '故事结构', '对话技巧'],
    author: '墨染',
    date: '2026-07-15',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20artist%20workspace%20with%20sketchbook%20and%20pens%20on%20wooden%20desk%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20soft%20bokeh%20background%2C%20cozy%20studio%20vibe&width=800&height=500&seq=article-script-01&orientation=landscape',
  },
  {
    id: 2,
    slug: 'tongren-jiaoben-juese-sudian',
    title: '同人脚本角色塑造：让角色活起来的秘诀',
    excerpt: '深入探讨同人漫画脚本中角色塑造的高级技巧，学习如何让二次创作的角色既忠于原作又富有新意。',
    content: `<p>在同人漫画创作中，角色塑造是最考验创作者功力的环节。如何在保留原作角色核心特质的同时，赋予他们新的魅力？本文将分享一系列实用的角色塑造技巧。</p>
<h2>一、理解原作的精髓</h2>
<p>在开始二次创作之前，必须深入理解原作中角色的核心特质。这包括角色的性格基础、行为模式、价值观念以及与其他角色的关系网络。只有充分理解了这些，才能在二次创作中做到不偏离角色本质。</p>
<p>建议反复阅读原作中与该角色相关的关键章节，记录角色的重要台词、标志性行为和情感变化节点。</p>
<h2>二、寻找创作空间</h2>
<p>优秀的同人创作往往在原作的"留白"处做文章。原作中没有详细展开的背景故事、角色在某个时间段内的经历、不同选择下的可能性分支，这些都是绝佳的创作空间。找到这些空间，让二次创作既有根基又有新意。</p>
<h2>三、给角色新的挑战</h2>
<p>将角色置于全新的情境中，观察他们会如何反应。这是检验角色塑造是否成功的重要方法。如果读者觉得"这个角色确实会这样做"，说明你的角色塑造是成功的。关键在于：角色的行为必须与其核心性格一致，但反应方式可以带来新鲜感。</p>
<h2>四、角色关系的深度挖掘</h2>
<p>同人创作的一大魅力在于可以深入探索原作中未被充分展开的角色关系。通过增加互动的深度和频率，展现角色之间更细腻的情感层次。注意保持角色互动的自然感，避免生硬地推进关系发展。</p>`,
    category: '脚本写作',
    categorySlug: 'jiaoben-xiezuo',
    tags: ['角色塑造', '人物设定', '角色关系', '创作技巧'],
    author: '星野',
    date: '2026-07-08',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=Anime%20character%20design%20sketches%20on%20paper%20with%20colorful%20marker%20pens%2C%20artistic%20workspace%2C%20soft%20natural%20light%2C%20creative%20studio%20atmosphere&width=800&height=500&seq=article-character-01&orientation=landscape',
  },
  {
    id: 3,
    slug: 'manhua-fenjing-goutu-faze',
    title: '漫画分镜构图法则：打造流畅的视觉叙事',
    excerpt: '系统学习漫画分镜的构图基本原理，掌握视线引导、画面节奏与页面布局的核心技巧。',
    content: `<p>分镜是漫画的灵魂。一个好的分镜能让读者流畅地跟随故事节奏，而糟糕的分镜则会让再精彩的故事也读起来索然无味。本文将系统讲解漫画分镜构图的核心法则。</p>
<h2>一、分镜的基本元素</h2>
<p>漫画分镜由以下几个基本元素构成：格框（コマ）、画面内的构图、人物与背景的位置关系、对话气泡的布局以及翻页节奏。每一个元素都影响着读者的阅读体验。</p>
<p>格框的大小和形状直接决定了该画面的重要程度和节奏感。大格框通常用于重要场景或需要强调的画面，小格框则用于过渡或快节奏的对话场景。</p>
<h2>二、视线引导技巧</h2>
<p>读者的视线在页面上的移动路径是可以被设计的。常用的视线引导方法包括：利用人物视线方向引导读者看向下一个格框、通过动作线的方向引导阅读顺序、利用背景元素的线条形成视觉引导。</p>
<p>在日本漫画的传统阅读顺序（从右到左）中，格框的排列需要配合这一阅读习惯，让读者的视线自然流动，不会产生困惑。</p>
<h2>三、画面节奏控制</h2>
<p>漫画的节奏感来自格框大小、数量和排列方式的变化。一个对开页上通常安排5-8个格框为宜，关键场景可以放大到一个跨页。在动作场景中，使用小格框快速切换可以营造紧张感；在抒情场景中，使用大格框留白可以放慢节奏。</p>
<h2>四、角度与景别的运用</h2>
<p>不同的镜头角度和景别传达不同的情感信息。俯视角度让角色显得弱小或孤独，仰视角度则赋予角色力量和威严。特写镜头强调情感细节，全景镜头交代环境氛围。灵活运用这些技巧，让画面更具表现力。</p>
<h2>五、跨页与出血设计</h2>
<p>跨页是漫画中最具冲击力的画面形式，通常用于高潮场景。出血（画面延伸到页面边缘）则能营造突破框架的动感。这两种技巧都需要在起稿阶段就做好规划，确保印刷或数字发布时的效果。</p>`,
    category: '分镜技巧',
    categorySlug: 'fenjing-jiqiao',
    tags: ['分镜', '构图', '视线引导', '节奏控制'],
    author: '墨染',
    date: '2026-07-20',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Manga%20storyboard%20layout%20sketches%20on%20drawing%20table%20with%20panel%20divisions%2C%20artist%20workspace%2C%20warm%20ambient%20lighting%2C%20creative%20process&width=800&height=500&seq=article-storyboard-01&orientation=landscape',
  },
  {
    id: 4,
    slug: 'fenjing-jingtou-yuyan-rumen',
    title: '分镜中的镜头语言：用画面讲述动人故事',
    excerpt: '学习如何运用电影级的镜头语言来设计漫画分镜，让静态的画面拥有动态的叙事力量。',
    content: `<p>漫画作为一种视觉叙事媒介，与电影有着深刻的共通之处。优秀的漫画家往往具备导演般的镜头意识。本文将从镜头语言的角度，探讨漫画分镜的设计方法。</p>
<h2>一、建立镜头与景别</h2>
<p>远景镜头用于交代故事发生的环境背景，让读者了解角色所处的世界。中景镜头是漫画中最常用的景别，适合展现角色之间的互动。特写镜头用于强调情感细节或关键物品，是推动情感高潮的重要手段。</p>
<h2>二、镜头运动的表现</h2>
<p>虽然漫画是静态的，但通过巧妙的构图可以表现镜头的运动感。例如，通过连续格框中景别由远及近的变化来模拟推镜效果，通过画面中人物的动态模糊线表现快速运动。这些技巧让静态的漫画页拥有了动态的节奏。</p>
<h2>三、主观镜头与客观镜头</h2>
<p>主观镜头让读者代入角色的视角，增强沉浸感。客观镜头则让读者以旁观者的身份观察故事。在关键的情感转折点使用主观镜头，往往能带来更强烈的情感共鸣。灵活切换两种镜头类型，让叙事层次更丰富。</p>
<h2>四、转场技巧</h2>
<p>漫画中的转场需要特别设计。常用的转场方式包括：场景切换格（一个格框中展示新场景的建立镜头）、时间过渡（通过季节标志或时钟等视觉元素暗示时间推移）、以及情绪转场（利用相似构图连接不同场景）。</p>`,
    category: '分镜技巧',
    categorySlug: 'fenjing-jiqiao',
    tags: ['镜头语言', '景别', '转场', '视觉叙事'],
    author: '星野',
    date: '2026-07-12',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Manga%20panel%20with%20dynamic%20camera%20angles%20sketched%20on%20paper%2C%20creative%20workspace%20with%20drawing%20tools%2C%20soft%20lighting%2C%20artistic%20atmosphere&width=800&height=500&seq=article-camera-01&orientation=landscape',
  },
  {
    id: 5,
    slug: 'shuzi-huihui-ruanjian-tuijian',
    title: '数字绘画软件推荐：同人漫画创作的得力工具',
    excerpt: '对比主流数字绘画软件的功能特点，帮助同人漫画作者选择最适合自己创作风格与预算的工具。',
    content: `<p>数字绘画已经成为同人漫画创作的主流方式。面对众多绘画软件，如何选择最适合自己的那一款？本文将从多个维度对比主流数字绘画软件，帮你做出明智的选择。</p>
<h2>一、Clip Studio Paint（CSP）</h2>
<p>CSP是目前同人漫画圈最受欢迎的绘画软件。它专为漫画创作设计，提供了强大的笔刷引擎、丰富的网点纸素材、便捷的分格工具和3D人偶辅助功能。EX版本还支持多页管理和书籍排版，是同人志制作的理想工具。</p>
<p>价格方面，CSP提供买断制和订阅制两种方式，PRO版本足以满足大多数同人作者的需求。</p>
<h2>二、Procreate</h2>
<p>iPad用户的首选。Procreate以其流畅的绘画体验和直观的界面设计著称。虽然它在漫画专用功能上不如CSP全面，但凭借出色的笔刷表现和便携性，成为了许多同人作者的日常绘画工具。配合Apple Pencil使用，手感接近传统纸笔。</p>
<h2>三、Photoshop</h2>
<p>作为图像处理的老牌霸主，Photoshop在色彩调整、后期处理方面的能力无可匹敌。但它的漫画专用功能相对薄弱，更多被用作辅助工具。如果你需要进行精细的色彩调整或特效制作，Photoshop是不二之选。</p>
<h2>四、免费替代方案</h2>
<p>预算有限的创作者可以考虑以下免费替代方案：Krita（功能全面的开源绘画软件），MediBang Paint（专为漫画设计的免费软件，提供云存储和团队协作功能），以及FireAlpaca（轻量级免费绘画软件，适合配置较低的设备）。</p>`,
    category: '绘制技法',
    categorySlug: 'huizhi-jifa',
    tags: ['数字绘画', '绘画软件', '工具推荐', 'Clip Studio Paint'],
    author: '墨染',
    date: '2026-07-25',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Digital%20drawing%20tablet%20with%20stylus%20on%20wooden%20desk%2C%20display%20showing%20anime%20style%20illustration%2C%20warm%20studio%20lighting%2C%20creative%20workspace&width=800&height=500&seq=article-software-01&orientation=landscape',
  },
  {
    id: 6,
    slug: 'xiantiao-yu-shangse-jiqiao',
    title: '线条与上色技巧：提升同人漫画画面质感',
    excerpt: '从线条的力度控制到色彩的搭配原理，全面讲解提升同人漫画画面质量的实用技法。',
    content: `<p>线条和色彩是漫画最基本也最重要的视觉元素。掌握了这两个要素，你的同人漫画作品就能在视觉上脱颖而出。本文将分享从入门到进阶的线条与上色技巧。</p>
<h2>一、线条的力度与变化</h2>
<p>一条有生命的线条应该有粗细变化。在人物轮廓处使用较粗的线条，在细节和内部结构处使用较细的线条。线条的起笔和收笔也应该有自然的力度变化，避免机械的均匀线条。</p>
<p>练习建议：每天进行线条练习，包括长直线、曲线、不同力度的笔触。可以使用传统纸笔，也可以在数字设备上进行。</p>
<h2>二、效果线与集中线</h2>
<p>效果线是漫画中常用的表现手法。集中线用于将读者的注意力引向画面焦点，速度线用于表现运动感，气氛线（如雨线、光线）用于营造氛围。这些线条的密度、角度和间距都需要精心设计。</p>
<h2>三、黑白灰的层次控制</h2>
<p>即使在黑白漫画中，通过网点纸或灰度填充也能营造丰富的视觉层次。亮面、灰面和暗面的比例需要根据场景氛围来调整。一般来说，轻松愉快的场景以亮调为主，紧张阴暗的场景以暗调为主。</p>
<h2>四、配色基础原理</h2>
<p>对于彩色同人漫画，配色是决定画面氛围的关键。了解色相环的基础知识：互补色营造强烈对比，邻近色营造和谐感，冷暖色调影响读者的情绪感知。建议为每部作品建立一个配色方案，保持视觉风格的一致性。</p>
<h2>五、光影的表现</h2>
<p>光影处理是提升画面立体感和氛围感的重要手段。确定光源方向后，按照光影规律为角色和背景添加阴影和高光。在情感强烈的场景中，可以适当夸张光影对比，增强戏剧效果。</p>`,
    category: '绘制技法',
    categorySlug: 'huizhi-jifa',
    tags: ['线条', '上色', '光影', '效果线'],
    author: '小夜',
    date: '2026-07-05',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20manga%20ink%20line%20art%20on%20paper%20with%20brush%20pens%2C%20artistic%20detail%2C%20warm%20lighting%2C%20creative%20process&width=800&height=500&seq=article-line-art-01&orientation=landscape',
  },
  {
    id: 7,
    slug: 'guonei-tongren-tougao-pingtai',
    title: '国内同人漫画投稿平台全攻略',
    excerpt: '详细介绍国内主流同人漫画投稿平台的特色、用户群体与投稿规范，助你找到最合适的发布渠道。',
    content: `<p>对于同人漫画创作者来说，选择合适的发布平台至关重要。不同的平台有着不同的用户群体、内容偏好和运营规则。本文将全面盘点国内主流同人漫画投稿平台。</p>
<h2>一、Lofter（乐乎）</h2>
<p>Lofter是国内最大的同人创作社区之一。它以标签系统为核心，用户可以方便地通过标签发现感兴趣的同人作品。Lofter支持图片、文字、音乐等多种内容形式，社区氛围友好，非常适合同人漫画创作者积累第一批读者。</p>
<p>优势：用户基数大、标签系统完善、社区互动活跃。注意：需要遵守平台的社区规范，适当处理敏感内容。</p>
<h2>二、微博</h2>
<p>微博虽然是综合性社交平台，但其超话社区和话题功能为同人创作者提供了良好的展示空间。精明的创作者会利用微博的传播特性，通过高质量的预告图和话题标签吸引关注。</p>
<p>建议将微博作为辅助平台，利用其传播优势将流量引导至主要发布平台。</p>
<h2>三、哔哩哔哩</h2>
<p>B站的专栏区和动态区都可以发布同人漫画作品。B站的用户群体与二次元高度重合，受众精准。通过漫画与视频内容的结合（如绘画过程视频），可以获得更好的曝光效果。</p>
<h2>四、Pixiv</h2>
<p>虽然Pixiv是日本平台，但它在国内同人圈同样拥有大量用户。Pixiv以高质量的插画和漫画作品著称，使用标签系统进行分类。支持多语言界面，是面向国际读者的理想选择。</p>
<h2>五、CPP（COMICUP）</h2>
<p>作为国内最大的同人展主办方，CPP的线上平台也值得关注。它更侧重于同人志的贩售，适合想要将作品实体化的创作者。</p>`,
    category: '发布平台',
    categorySlug: 'fabu-pingtai',
    tags: ['投稿平台', 'Lofter', '微博', 'Pixiv', '同人社区'],
    author: '星野',
    date: '2026-08-01',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20anime%20art%20community%20app%20interface%20on%20wooden%20desk%2C%20warm%20ambient%20light%2C%20modern%20workspace%2C%20clean%20aesthetic&width=800&height=500&seq=article-platform-cn-01&orientation=landscape',
  },
  {
    id: 8,
    slug: 'haiwai-tongren-pingtai-zhi-nan',
    title: '海外同人漫画平台指南：走向国际的第一步',
    excerpt: '详解海外主流同人发布平台的注册、发布与运营技巧，帮助同人漫画作者拓展国际读者群体。',
    content: `<p>随着同人文化的全球化发展，越来越多的同人漫画作者开始将目光投向海外平台。本文将为有意拓展国际读者的创作者提供一份实用的海外平台指南。</p>
<h2>一、Pixiv</h2>
<p>Pixiv是全球最大的二次元创作社区之一，月活跃用户超过5000万。平台以日文为主，但支持多语言标签和界面。发布作品时建议同时使用日文和英文标签，以最大化曝光率。Pixiv的排行榜和推荐算法对新人相对友好，优质作品有机会获得大量关注。</p>
<h2>二、Twitter（X）</h2>
<p>Twitter是海外同人创作者最活跃的社交平台。通过使用相关标签（如#FanArt、#同人誌等），作品可以被全球的同好发现。建议建立固定的更新节奏，通过持续的高质量内容积累粉丝。</p>
<h2>三、DeviantArt</h2>
<p>作为老牌艺术社区，DeviantArt拥有庞大的国际用户群。平台以西方用户为主，对日式漫画风格的接受度也在不断提高。DeviantArt的分类体系细致，适合各类风格的同人作品。</p>
<h2>四、Webtoon / Tapas</h2>
<p>如果你的同人漫画采用条漫格式，Webtoon和Tapas是理想的选择。这两个平台专注于移动端阅读体验，支持创作者通过广告分成和读者打赏获得收入。条漫格式在叙事节奏上与传统页漫有所不同，需要针对性调整。</p>
<h2>五、Tumblr</h2>
<p>Tumblr在同人圈有着深厚的文化根基。虽然近年用户有所流失，但其标签系统和转发机制仍然是同人作品传播的有效渠道。Tumblr对成人内容的限制相对宽松（但需遵守平台最新政策），适合各种风格的同人创作。</p>`,
    category: '发布平台',
    categorySlug: 'fabu-pingtai',
    tags: ['海外平台', 'Pixiv', 'Twitter', 'Webtoon', '国际发布'],
    author: '墨染',
    date: '2026-07-28',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Globe%20with%20social%20media%20icons%20floating%20around%20on%20minimal%20desk%2C%20international%20communication%20concept%2C%20warm%20lighting%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-platform-intl-01&orientation=landscape',
  },
  {
    id: 9,
    slug: 'tongren-chuangzuo-banquan-jichu',
    title: '同人创作版权基础：你需要知道的法律常识',
    excerpt: '系统梳理同人漫画创作中涉及的版权法律问题，帮助创作者在法律边界内安全创作。',
    content: `<p>版权问题是同人创作者最关心也最容易困惑的议题之一。同人创作游走于原创与二创之间，了解相关法律常识，既是对原作的尊重，也是保护自己创作成果的必要手段。</p>
<h2>一、同人创作的法律地位</h2>
<p>在日本，同人创作被认为处于一个法律上的灰色地带。严格来说，未经原作版权方许可的二次创作可能构成侵权。但在实践中，大多数版权方对同人创作采取默许态度，因为这有助于维持作品的热度和粉丝活跃度。</p>
<p>在中国，著作权法同样保护原创者的权利。同人创作如果未经授权使用了原作的实质性元素（角色、世界观、标志性设定等），在法律上存在侵权风险。</p>
<h2>二、版权方的态度与政策</h2>
<p>不同版权方对同人创作的态度差异很大。部分版权方（如Type-Moon）对同人创作持开放态度，甚至出台了明确的二次创作指南。而有些版权方（如迪士尼）则严格维护其知识产权。在开始创作前，建议查阅相关版权方的二次创作政策。</p>
<h2>三、合理使用的边界</h2>
<p>合理使用是同人创作的重要法律支撑。判断是否构成合理使用通常考虑以下因素：使用的目的和性质（非商业性使用更可能被认定为合理使用）、原作的使用比例、对原作市场的影响等。但需要注意的是，这些标准在不同国家的法律体系中有所不同。</p>
<h2>四、保护自己的创作</h2>
<p>同人创作者同样拥有对其原创部分的著作权。你在同人作品中创作的原创角色、原创剧情、独特的视觉表达等，都受到著作权法的保护。如果有人未经许可使用你的这些原创内容，你可以依法维权。</p>
<h2>五、商业化注意事项</h2>
<p>当同人创作涉及商业化（如同人志贩售、委托创作等）时，版权风险会显著增加。建议在商业化前，尽可能了解版权方的政策，避免使用过于近似的商标和标志性元素，并考虑为原创部分进行版权登记。</p>`,
    category: '版权须知',
    categorySlug: 'banquan-xuzhi',
    tags: ['版权', '法律常识', '合理使用', '二次创作'],
    author: '小夜',
    date: '2026-08-05',
    readTime: 10,
    image: 'https://readdy.ai/api/search-image?query=Law%20book%20and%20gavel%20on%20wooden%20desk%20with%20soft%20natural%20light%2C%20legal%20concept%2C%20warm%20professional%20atmosphere&width=800&height=500&seq=article-copyright-01&orientation=landscape',
  },
  {
    id: 10,
    slug: 'tongrenzhi-zhizuo-yu-fanshou',
    title: '同人志制作与贩售全流程指南',
    excerpt: '从排版设计、印刷选择到展会贩售与在线销售，完整讲解同人志从创作到送达读者手中的全过程。',
    content: `<p>将数字作品实体化，制作成精美的同人志，是许多同人漫画作者的梦想。本文将全面讲解同人志制作与贩售的全流程。</p>
<h2>一、同人志的策划与规划</h2>
<p>在开始制作之前，需要明确以下问题：同人志的主题和内容、页数规模、印刷数量、预算范围以及目标售价。这些因素相互影响，需要综合考虑。初次制作建议从薄本（20-40页）开始，控制成本和风险。</p>
<h2>二、排版与设计</h2>
<p>同人志的排版需要注意以下几点：出血位（通常为3mm）的设置、安全框内的内容放置、书脊厚度的计算以及扉页和版权页的设计。推荐使用Clip Studio Paint EX或InDesign进行排版。字体选择上，正文使用易读的宋体或黑体，标题可以使用更具设计感的字体。</p>
<h2>三、印刷选择</h2>
<p>国内同人志印刷主要分为数码印刷和胶版印刷两种。数码印刷适合小批量（100本以下），成本较低，但色彩表现略逊。胶版印刷适合大批量，色彩准确，但起印量高。纸张选择方面，封面常用铜版纸或特种纸，内页常用胶版纸或轻涂纸。</p>
<h2>四、展会贩售</h2>
<p>COMICUP（CP）是国内最大的同人展，每年在上海举办多届。此外，还有成都CD、广州萤火虫等地方性展会。参展需要提前申请摊位，准备展示用品（桌布、展示架、宣传品），并规划好定价和优惠策略。</p>
<h2>五、线上销售渠道</h2>
<p>除了展会贩售，线上销售也是重要的渠道。淘宝、CPP线上平台以及自建通贩页面都是常见选择。需要注意包装和物流的细节，确保同人志安全送达读者手中。同时，要建立清晰的库存管理流程。</p>`,
    category: '版权须知',
    categorySlug: 'banquan-xuzhi',
    tags: ['同人志', '印刷', '展会', '贩售', '排版设计'],
    author: '墨染',
    date: '2026-07-22',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20beautifully%20printed%20manga%20doujinshi%20books%20on%20wooden%20table%2C%20warm%20lighting%2C%20artistic%20book%20display%2C%20creative%20publishing&width=800&height=500&seq=article-doujinshi-01&orientation=landscape',
  },
];

export const featuredArticles = [1, 3, 5, 7, 9];

export const faqs = [
  {
    question: '同人漫画创作需要具备绘画基础吗？',
    answer: '不一定。同人漫画创作的形式非常多样，即使绘画基础较弱，也可以通过简笔画风格、四格漫画形式，或者与画师合作来开始创作。重要的是故事的创意和热情。当然，如果希望提升画面质量，适当的绘画练习会有很大帮助。',
  },
  {
    question: '同人漫画可以在哪里免费发布？',
    answer: '国内可在Lofter、微博、哔哩哔哩等平台免费发布；海外可在Pixiv、Twitter、DeviantArt等平台免费发布。每个平台的用户群体和内容风格有所不同，建议根据作品类型选择1-2个主平台深耕。',
  },
  {
    question: '同人漫画创作会侵犯原作版权吗？',
    answer: '在法律层面上，未经授权的二次创作确实存在版权风险。但实践中，大多数日本版权方对非商业性同人创作持默许态度。建议避免直接复制原作内容，加入足够的原创元素，并在商业化前充分了解版权方政策。',
  },
  {
    question: '新手如何开始写同人漫画脚本？',
    answer: '建议从短篇开始，先确定一个简单的核心创意（一个有趣的"如果"），然后围绕这个创意设计3-5个关键场景，再填充对话和细节。不需要一开始就追求完美，完成比完美更重要。也可以从改写原作中的某个场景开始练习。',
  },
  {
    question: '同人志印刷一般需要多少预算？',
    answer: '以一本40页A5大小的黑白同人志为例，数码印刷100本的成本大约在1500-2500元之间。如果选择胶版印刷，起印量通常在300-500本，单本成本会降低但总投入更高。建议首次制作控制印量，根据需求再追加印刷。',
  },
  {
    question: '画同人漫画用什么软件最好？',
    answer: '目前最推荐的是Clip Studio Paint（CSP），它专为漫画设计，功能全面。iPad用户可以选择Procreate。预算有限的可以使用免费的MediBang Paint或Krita。关键是选一个顺手并坚持使用的工具。',
  },
];